import * as types from '../../config/actions';

const initialState = {
  sessionId: null,
  isSocketConnected: false,
  isSyncing: false,
  stage: 'idle', // idle | discovery | auditing | completed | failed
  discoveredUrls: [],
  urlData: {}, // Normalized map for O(1) lookups
  completedCount: 0,
  totalPages: 0,
};

export default function auditProgressReducer(state = initialState, action) {
  switch (action.type) {
    case types.AUDIT_PROGRESS_INITIALIZE:
      return { ...initialState, sessionId: action.payload.sessionId };

    case types.AUDIT_PROGRESS_SYNC_START:
      return { ...state, isSyncing: true, discoveredUrls: [], urlData: {} };

    case types.AUDIT_PROGRESS_SYNC_COMPLETE:
      return { ...state, isSyncing: false };

    case types.AUDIT_PROGRESS_BULK_SYNC: {
      const nextUrlData = { ...state.urlData };
      const nextDiscoveredUrls = [...state.discoveredUrls];

      // Initialize counters from existing state
      let nextCompletedCount = state.completedCount || 0;
      let nextStage = state.stage;

      action.payload.forEach(({ type, data }) => {
        if (type === 'DISCOVERY') {
          nextStage = 'discovery';
          const url = data.discoveredUrl;
          if (!nextUrlData[url]) {
            nextDiscoveredUrls.push(url);
            nextUrlData[url] = { status: 'discovered' };
          }
        } else if(type === 'AUDIT_PENDING') {
          nextStage = 'auditing';

          const { url, violations, index } = data;

          nextUrlData[url] = {
            ...nextUrlData[url],
            status: 'pending',
            violations,
            index,
          };
        } else if (type === 'AUDIT_COMPLETE') {
          nextStage = 'auditing';
          const { url, violations, index } = data;

          // ONLY increment if the status wasn't already 'complete'
          if (nextUrlData[url]?.status !== 'complete') {
            nextCompletedCount++;
          }

          nextUrlData[url] = {
            ...nextUrlData[url],
            status: 'complete',
            violations,
            index,
          };
        } else if (type === 'AUDIT_FAILED') {
          nextStage = 'auditing';
          const { url, error } = data;

          // If it was 'complete' and now it's an 'error', decrement
          if (nextUrlData[url]?.status === 'complete') {
            nextCompletedCount--;
          }

          nextUrlData[url] = {
            ...nextUrlData[url],
            status: 'error',
            error,
          };
        }
      });

      return {
        ...state,
        stage: nextStage,
        discoveredUrls: nextDiscoveredUrls,
        urlData: nextUrlData,
        completedCount: nextCompletedCount, // Now O(1) to access in UI
        totalPages: nextDiscoveredUrls.length, // This is your "Total"
      };
    }

    case types.AUDIT_PROGRESS_PAGE_DISCOVERY_COMPLETED:
      return {
        ...state,
        stage: 'auditing',
        totalPages: action.payload.discoveredUrls.length,
      };

    case types.AUDIT_PROGRESS_SESSION_COMPLETED:
      return { ...state, stage: 'completed' };

    case types.AUDIT_PROGRESS_CLEANUP:
      return initialState;

    default:
      return state;
  }
}
